import styled from 'styled-components'

import { Heading2 } from 'components/Typography'

import { VerticalProgressBar } from '../shared/VerticalProgressBar'

export const StyledVerticalProgressBar = styled(VerticalProgressBar)`
  margin-top: 36px;
`

export const StyledTitle = styled(Heading2)`
  font-size: 40px;
  font-weight: 600;
  line-height: 55px;
  margin: 60px auto 6px;
  text-align: left;
`
